import { render, staticRenderFns } from "./XmPreviewMedia.vue?vue&type=template&id=54d46351&scoped=true"
import script from "./XmPreviewMedia.vue?vue&type=script&lang=js"
export * from "./XmPreviewMedia.vue?vue&type=script&lang=js"
import style0 from "./XmPreviewMedia.vue?vue&type=style&index=0&id=54d46351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d46351",
  null
  
)

export default component.exports